import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.854 4.667h-.666V4a2 2 0 0 0-2-2H3.52a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h9.333a2 2 0 0 0 2-2V6.667a2 2 0 0 0-2-2M3.521 3.333h6.667a.666.666 0 0 1 .666.667v.667H3.521a.667.667 0 1 1 0-1.334m10 6.667h-.667a.667.667 0 1 1 0-1.333h.667zm0-2.667h-.667a2 2 0 0 0 0 4h.667V12a.667.667 0 0 1-.667.667H3.521A.667.667 0 0 1 2.854 12V5.887A2 2 0 0 0 3.521 6h9.333a.667.667 0 0 1 .667.667z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })